<template>
    <div class="row" ref="rootEl">
        <!-- CÓDIGO -->
        <div class="form-item-char10">
            <label class="label-caption">Equipamento</label>
            <input
                type="text"
                class="input-right"
                v-model="edCdCadastro"
                v-number
                maxlength="10"
                @keyup.enter="onEnterCodigo"
                @blur="onBlurCodigo"
            />
        </div>


        <!-- LABEL (visão) -->
        <div v-if="!modoPesquisa" class="form-item">
            <label class="label-caption">Nome</label>
            <div class="field-label" @click="ativarPesquisa">{{ nmEquipamento }}</div>
        </div>


        <!-- INPUT (pesquisa) -->
        <div v-if="modoPesquisa" class="form-item" style="position:relative;">
            <label class="label-caption" for="nmPesquisa">Pesquisar Nome</label>
            <input
                type="text"
                id="nmPesquisa"
                ref="nmPesquisaInput"
                v-model="edNmPesquisa"
                maxlength="80"
                v-uppercase
                autocomplete="off"
                @keydown.down.prevent="move(1)"
                @keydown.up.prevent="move(-1)"
                @keydown.enter.prevent="confirmActive"
                @keydown.esc.prevent="cancelarPesquisa"
                @blur="onBlurPesquisa"
                style="flex:1;"
            />

                <!-- DROPDOWN -->
            <div v-if="openList" class="lookup-panel">
                <div v-if="isLoading" class="ac-loading">Buscando…</div>
                <template v-else>
                    <div v-if="lsDados.length === 0" class="ac-empty">Nenhum registro encontrado</div>
                    <ul class="lookup-list">
                        <li
                            v-for="(item, idx) in lsDados"
                            :key="item.id || idx"
                            class="lookup-item"
                            :class="{ 'is-active': idx === activeIndex }"
                            @mousedown.prevent="selecionar(item)"
                            @mousemove="activeIndex = idx"
                            :title="item.nmequipamento"
                        >
                            <span class="lookup-item-name">{{ item.nmequipamento }}</span>
                            <span v-if="item.placa" class="lookup-item-sub">{{ item.placa }}</span>
                        </li>
                    </ul>
                </template>
            </div>
        </div>


        <button v-if="modoPesquisa" type="button" class="button-close" @click="cancelarPesquisa" />
    </div>
</template>

<script setup>
import { ref, watch, nextTick, onMounted, onBeforeUnmount } from 'vue'
import { Api } from '@/funcoes/apiExport'
import { Funcoes } from '@/funcoes/utils'
import { globalStore } from '@/globals'

const emit = defineEmits(['update:idSelecionado', 'update:objSelecionado']);
const props = defineProps({
    initId: { type: Number, default: null},
});

const edCdCadastro = ref(null)
const edNmPesquisa = ref(null)
const nmEquipamento = ref(null)
const modoPesquisa = ref(false)

const isLoading = ref(false)
const lsDados = ref([])
const openList = ref(false)
const activeIndex = ref(-1)
const NAME_MIN = 3

let debounceHandle = null
let debounceHandleNome = null
let lastQueriedCod = null
let programmatic = false
const rootEl = ref(null)
const nmPesquisaInput = ref(null)


function atualizarSelecao(obj) {
    nmEquipamento.value = obj?.nmequipamento ?? null
    if (programmatic) lastQueriedCod = obj?.cdequipamento ?? null
    edCdCadastro.value = obj?.cdequipamento ?? null
    emit('update:idSelecionado', obj?.id ?? null)
    emit('update:objSelecionado', obj ?? null)
}

function limparSelecao() {
    nmEquipamento.value = null
    emit('update:idSelecionado', null)
    emit('update:objSelecionado', null)
}


async function lerDados() {
    const pesquisandoPorNome = !!modoPesquisa.value

    if (!programmatic){
        if (pesquisandoPorNome) {
            const q = (edNmPesquisa.value ?? '').trim()
            if (!q) { lsDados.value = []; openList.value = false; return }
        } else {
            const cod = Funcoes.integerFromString(edCdCadastro.value)
            if (cod < 1) return
            if (cod === lastQueriedCod) return
            lastQueriedCod = cod
        }
    }

    try {
        isLoading.value = true
        const payload = {
            id: (programmatic) ? props.initId : null,
            idmunicipio: globalStore.idmunicipio,
            cdcadastro: pesquisandoPorNome ? null : Funcoes.integerFromString(edCdCadastro.value),
            nmpesquisar: pesquisandoPorNome ? (edNmPesquisa.value ?? '').trim() : null,
            ativo: 'S'
        }

        const resp = await Api.genericPost('/listas/equipamentos', payload)
        lsDados.value = Array.isArray(resp) ? resp : []

        if (programmatic){
            if (lsDados.value.length === 1) {
                atualizarSelecao(lsDados.value[0]);
            }

        }else if (!pesquisandoPorNome) {
            if (lsDados.value.length === 1) {
                selecionar(lsDados.value[0])
            } else if (lsDados.value.length === 0) {
                limparSelecao()
            } else {
                openList.value = true
                activeIndex.value = lsDados.value.length ? 0 : -1
            }
        } else {
            openList.value = true
            activeIndex.value = lsDados.value.length ? 0 : -1
        }
    } finally {
        isLoading.value = false;
        setTimeout(() => { programmatic = false }, 0);
    }
}


function onEnterCodigo() {
    clearTimeout(debounceHandle)
    lerDados()
}


function onBlurCodigo() {
    const cod = Funcoes.integerFromString(edCdCadastro.value)
    if (cod !== lastQueriedCod) {
        clearTimeout(debounceHandle)
        lerDados()
    }
}


watch(edCdCadastro, (v) => {
    clearTimeout(debounceHandle)
    const cod = Funcoes.integerFromString(v)

    if (cod !== lastQueriedCod) {
        nmEquipamento.value = null
        emit('update:idSelecionado', null)
        emit('update:objSelecionado', null)
    }

    if (cod <= 0 || cod === lastQueriedCod) return
    debounceHandle = setTimeout(() => lerDados(), 350)
})


function ativarPesquisa() {
    modoPesquisa.value = true
    edNmPesquisa.value = ''
    lsDados.value = []
    openList.value = false
    activeIndex.value = -1
    lastQueriedCod = null
    clearTimeout(debounceHandle)
    nextTick(() => nmPesquisaInput.value?.focus())
}


function cancelarPesquisa() {
    modoPesquisa.value = false
    openList.value = false
    lsDados.value = []
    activeIndex.value = -1
    edNmPesquisa.value = ''
}


function onBlurPesquisa() {
    setTimeout(() => { openList.value = false }, 120)
}


function move(delta) {
    if (!openList.value || lsDados.value.length === 0) return
    const next = activeIndex.value < 0 ? 0 : activeIndex.value + delta
    const max = lsDados.value.length - 1
    activeIndex.value = Math.max(0, Math.min(next, max))
}


function confirmActive() {  
    if (activeIndex.value >= 0 && lsDados.value[activeIndex.value]) {
        selecionar(lsDados.value[activeIndex.value])
    } else if (lsDados.value.length === 1) {
        selecionar(lsDados.value[0])
    }
}


function selecionar(item) {
    atualizarSelecao(item)
    cancelarPesquisa()
}


function onDocClick(e) {
    if (!modoPesquisa.value) return
    if (!rootEl.value) return
    if (!rootEl.value.contains(e.target)) cancelarPesquisa()
}


watch(edNmPesquisa, (v) => {
    if (!modoPesquisa.value) return
    clearTimeout(debounceHandleNome)

    const q = (v ?? '').trim()
    if (q.length < NAME_MIN) {
        lsDados.value = []
        openList.value = false
        activeIndex.value = -1
        return
    }

    openList.value = true
    activeIndex.value = -1
    debounceHandleNome = setTimeout(() => {
        lerDados()
    }, 400)
})


watch(() => props.initId, (novo) => {
    if (novo && novo > 0) {
        programmatic = true;
        lerDados();
    } else { limparSelecao(); edCdCadastro.value = null; lastQueriedCod = null }
})


onMounted(() => {
    if (props.initId && props.initId > 0) {
        programmatic = true;
        lerDados();
    }
})

onMounted(() => document.addEventListener('mousedown', onDocClick))
onBeforeUnmount(() => document.removeEventListener('mousedown', onDocClick))
</script>

<style scoped src="@/assets/css/layoutFrames.css"></style>
